import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import * as lookup from "../../../static/lookup.json"
import * as jounrneyJSON from "../../../static/journeyssr.json"

import { SectionContext } from "../context/sectionContext"
import { ConditionContext } from "../context/conditionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import {
  generateBI,
  fetchAllJourneyData,
  pdfDownload,
  uploadDocument,
  saveApplication,
  fetchApplicationDetails,
  sendEmailBI,
  s3uploadPdfBI,
} from "../../services/apiservice"
import {
  getDateInFormat,
  getStateFromCode,
  getAge,
  findCurrentJourneyCode,
  getValueFromLookup,
  findRiderSA,
  findRiderSAPercent,
  getSourceFromChannel
} from "../services/helperFunctions"
import {
  errorToastr,
  successToastr,
  clearToastr,
} from "../../services/error-handler"
import { wordCapital, lineCapital, applyComma } from '../../shared/functions'
// import { window, document } from "browser-monads"

const RadioContainer = styled.div`
  width: 100%;
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background-color: #fff;
    padding: 2px 5px;
    z-index: 999;
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
    & > .radio-label {
      text-align: center;
    }
  }

  .card {
    border-radius: 1rem;
    padding: 2rem 0;
    border-radius: 15px;
    background-color: #fff;
    position: relative;
    margin: 0px;
    margin-bottom: 0px;
    cursor: pointer;
    height: 13rem;
    margin-top: 0px;
    box-shadow: 0px 0px 20px #ccc;
    transition: all 200ms;

    .amount {
      color: black;
      margin-bottom: 2rem;
      margin-left: 8rem;
      border-left: 1px solid #ccc;
      padding-left: 2rem;
      height: 3rem;
      font-size: 21px;
    }
    .desc {
      padding: 0.8rem;
      background: #ededed;
      color: black;
      text-align: center;
    }
  }

  /*Check tick start  */
  .checked {
    background: #ededed;
    color: #ededed;
    position: absolute;
    left: 2rem;
    top: 2rem;
    height: 3rem;
    width: 3rem;
    border-radius: 50%;
    padding: 8px;
    & > * {
      font-size: 1.2rem;
    }
  }

  input:checked ~ .card .checked {
    background: #fff;
    color: ${props =>
    props.channel === "A"
      ? "#3e505d"
      : props.channel === "B"
        ? "#a20a3a"
        : props.channel === "C"
          ? "#0ab0ef"
          : "#eb7f25"};
    color: var(--lumiq-card-bg);
  }
  /*Check tick end */

  .icon-container {
    font-size: 3rem;
    padding: 1rem;
    span {
      border-radius: 50%;
      padding: 1rem;

      background: #3e505d;
      .hero-icon {
        padding-top: 8px;
        color: #fff;
      }
    }
  }

  input:checked ~ .card {
    background-color: ${props =>
    props.channel === "A"
      ? "#3e505d"
      : props.channel === "B"
        ? "#a20a3a"
        : props.channel === "C"
          ? "#0ab0ef"
          : "#eb7f25"};
    background-color: var(--lumiq-card-bg);
    color: #fff;
    .icon-container-1 {
      span {
        background: #fff;
        .hero-icon {
          color: #3e505d;
        }
      }
    }

    .amount {
      color: white;
      margin-bottom: 2rem;
      margin-left: 8rem;
      border-left: 1px solid #ccc;
      padding-left: 2rem;
      padding-top: .5rem;
      height: 3rem;
    }
    .desc {
      padding: 0.8rem;
      background: #fff;
      color: black;
      text-align: center;
    }
  }

  input:not(:checked) ~ .card {
    /* opacity: 0.5; */
    .amount{
      color:#818181;
    }

    .desc{
      color:#3e505d;
    }
  }
`

export default function BenefitIllustration(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)

  const [allJourneyData, setAllJourneyData] = useState()
  const [biApiData, setBiApiData] = useState()
  const [payNowOrLater, setPayNowOrLater] = useState("now")
  const [pdfData, setPdfData] = useState("")
  const [agreeToDeclaration, setAgreeToDeclaration] = useState(true)
  const [proceedWithOption, setProceedWithOption] = useState()
  const [location, setLocation] = useState()
  const [isChecked, setIsChecked] = useState(true);
  //Helper Functions
  async function downloadLinkOfPdf(Base64Pdf) {
    // if(!location){
    //   const result = await s3uploadPdfBI({applicationNumber: journeyState.applicationNo,
    //     Base64Pdf: Base64Pdf,
    //   })
    //   setLocation(result.data.location)
    //   window.open(result.data.location,"_self");
    // }else{
    //   window.open(location,"_self");
    // }
    const fileName = `${lookup?.pdfProdutPlanName[journeyState?.journeyIdFromStrapi] ?? ""}_${journeyState.applicationNo}.pdf`
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      var byteCharacters = atob(Base64Pdf)
      var byteNumbers = new Array(byteCharacters.length)
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      var byteArray = new Uint8Array(byteNumbers)
      var blob = new Blob([byteArray], { type: "application/pdf" })
      window.navigator.msSaveOrOpenBlob(blob, fileName)
      return
    }

    // For Other Browsers
    const linkSource = "data:application/pdf;base64," + Base64Pdf
    const link = document.createElement("a")
    link.href = linkSource
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    link.remove()

    window.addEventListener(
      "focus",
      function () {
        URL.revokeObjectURL(link.href)
      },
      { once: true }
    )
  }

  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

  const downloadPdf = async () => {
    let sendEmailPdfData = pdfData
    if (!sendEmailPdfData) {
      if (!biApiData) {
        return
      } else {
        let pdfResult = await pdfDownload({
          applicationNumber: journeyState.applicationNo,
          TID: biApiData?.TransactionId || "",
        })
        setPdfData(pdfResult.data.Base64Pdf)
        sendEmailPdfData = pdfResult.data.Base64Pdf
      }
    }
    downloadLinkOfPdf(sendEmailPdfData)
  }

  const printPdf = async () => {
    if (pdfData) {
      printPdf1(pdfData)
    } else {
      let pdfResult = await pdfDownload({
        applicationNumber: journeyState.applicationNo,
        TID: biApiData?.TransactionId || "",
      })
      setPdfData(pdfResult.data.Base64Pdf)
      printPdf1(pdfResult?.data?.Base64Pdf)
    }

    function printPdf1(base64Data) {
      const newWindow = window.open("", "", "width=100, height=100")
      if (newWindow) {
        const document = newWindow.document.open()
        document.close()
        newWindow.moveTo(0, 0)
        newWindow.resizeTo(window.screen.width, window.screen.height)
        const contentType = "application/pdf"
        const b64Data = base64Data
        const blob = b64toBlob(b64Data, contentType)
        const blobUrl = URL.createObjectURL(blob)
        document.write(`<iframe id="pdfDocument"
        src="${blobUrl}" 
        width="100%"
        height="100%"
        frameBorder="0" ></iframe>`)
        const docs = document.getElementById("pdfDocument")
        setTimeout(() => {
          docs.contentWindow.print()
        }, 1000)
      }
    }
    function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || ""
      sliceSize = sliceSize || 512

      var byteCharacters = atob(b64Data)
      var byteArrays = []

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)

        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        var byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      var blob = new Blob(byteArrays, { type: contentType })
      return blob
    }
  }

  const sendEmail = async (callS3uploadPdf) => {
    let sendEmailPdfData = pdfData
    if (!sendEmailPdfData) {
      if (!biApiData) {
        return
      } else {
        let pdfResult = await pdfDownload({
          applicationNumber: journeyState.applicationNo,
          TID: biApiData?.TransactionId || "",
        })
        setPdfData(pdfResult.data.Base64Pdf)
        sendEmailPdfData = pdfResult.data.Base64Pdf
      }
    }
    let payload = {
      journeyId: journeyState.journeyId,
      module: "BIEMAIL",
      BIPDF: sendEmailPdfData,
      applicationNumber: callS3uploadPdf ? journeyState.applicationNo : "",
      callS3uploadPdf : callS3uploadPdf 
    }
    sendEmailBI(payload).then(res => {
      console.log(res, "emailRes")
      if (res?.status) {
        successToastr(res.message)
      } else {
        errorToastr(res.message)
      }
    })
  }

  //async function to make API call
  const getData = async () => {
    let applicationDetailsPayload = {
      _id: journeyState.journeyId,
    }
    let applicationResult = await fetchApplicationDetails(
      applicationDetailsPayload
    )

    let payload = {
      journeyId: journeyState.journeyId,
      allRowData: true,
    }
    let journeyResult = await fetchAllJourneyData(payload)
    if (journeyResult?.lifeAssuredDetails?.proceedWith) {
      setProceedWithOption(journeyResult?.lifeAssuredDetails?.proceedWith)
    }
    generateBI(payload).then(async data => {
      console.log(journeyResult, data, "vjhdvhhs")
      setAllJourneyData(journeyResult)
      setJourneyState(prev => {
        return {
          ...prev,
          // premium:
          //   journeyState.planOption === "IATML"
          //     ? JSON.parse(data?.data?.BIJson)[0].TOTAL_5
          //     : journeyState.planOption === "IBTML"
          //       ? (
          //         JSON.parse(data?.data?.BIJson)[0].TOTAL_BASE_PREM_TAX +
          //         JSON.parse(data?.data?.BIJson)[0].TOTAL_PREM_TAX_SPOUSE || 0
          //       )?.toFixed(2)
          //       : "",
          premium:
            (data?.data?.finalKeys?.PREMIUM || 0),
            
          journeyData: applicationResult.applicationData,
        }
      })
      let pdfResult = await pdfDownload({
        applicationNumber: journeyState.applicationNo,
        TID: data.data.TransactionId || "",
      })
      setPdfData(pdfResult.data.Base64Pdf)
      setBiApiData(data.data)
    })
    .catch(err => {
      console.log("error in save application of save application and call BI function")
    })
  }

  const handleEnterPayoutOption = (event, value) => {
    console.log(event.key);
    if (event.key == 'Enter') {
      handlePayOption({ target: { value: value } })
    }

  }

  //Use Effects
  useEffect(async () => {
    await getData();
  }, [])

  // useEffect(() => {
  //   storePdfData()
  // }, [biApiData])

  //Page Functions
  const handlePayOption = ({ target }) => {
    console.log(target.value, "value in BI");
    if (target.value === "now") {
      setPayNowOrLater("now")
    } else if (target.value === "later") {
      setPayNowOrLater("later")
    }
  }

  const handlePrevious = () => {
    if (proceedWithOption === "manually") {
      props.setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page
      setJourneyState(prev => {
        return {
          ...prev,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
    }
  }

  // code of tab enter
  const handleEnterPrevious = (event) => {
    if (event?.key == 'Enter') {
      handlePrevious();
    }
  }
  // code of tab enter
  const handleEnterDownload = (event) => {
    if (event?.key == 'Enter') {
      downloadPdf();
    }
  }
  // code of tab enter
  const handleEnterPrint = (event) => {
    if (event?.key == 'Enter') {
      printPdf();
    }
  }
  // code of tab enter
  const handleEnterEmail = (event) => {
    if (event?.key == 'Enter') {
      sendEmail(false);
    }
  }
  // code of tab enter
  const handleEnterRecalculate = (event) => {
    if (event?.key == 'Enter') {
      handleReCalculate();
    }
  }

  const handleProceed = async ev => {
    if (!isChecked) {
      return;
    }
    // downloadLinkOfPdf(pdfData);
    sendEmail(true);
    // const result = await s3uploadPdfBI({
    //   applicationNumber: journeyState.applicationNo,
    //   Base64Pdf: pdfData,
    // })
    // const b64Data = pdfData
    // const blob = b64toBlob(b64Data, "application/pdf")
    // let formData = new FormData()
    // if (blob) {
    //   const file = blob
    //   formData.append("doc", file)
    //   formData.append("sub", false)
    //   formData.append("docPurpose", "BIPDF")
    //   try {
    //     const res = await uploadDocument(formData, journeyState.applicationNo)
    //     console.log({ res })
    //   } catch (error) {
    //     console.log(error)
    //   }
    // }
    // function b64toBlob(b64Data, contentType, sliceSize) {
    //   contentType = contentType || ""
    //   sliceSize = sliceSize || 512

    //   var byteCharacters = atob(b64Data)
    //   var byteArrays = []

    //   for (
    //     var offset = 0;
    //     offset < byteCharacters.length;
    //     offset += sliceSize
    //   ) {
    //     var slice = byteCharacters.slice(offset, offset + sliceSize)

    //     var byteNumbers = new Array(slice.length)
    //     for (var i = 0; i < slice.length; i++) {
    //       byteNumbers[i] = slice.charCodeAt(i)
    //     }

    //     var byteArray = new Uint8Array(byteNumbers)

    //     byteArrays.push(byteArray)
    //   }

    //   var blob = new Blob(byteArrays, { type: contentType })
    //   return blob
    // }

    if (payNowOrLater === "now") {
      let temp = journeyState.journeySteps.pages
      if(["fillProposalForm", "pageISelect360FillProposalForm"].includes(temp[2].pageId)){
        let element = temp[3]
        temp.splice(3, 1)
        temp.splice(2, 0, element)
      }
      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: {
            pages: temp,
          },
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          paymentStep: "N",
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
    }else{
      let temp = journeyState.journeySteps.pages
      if(["makePayment"].includes(temp[2].pageId)){
        let element = temp[3]
        temp.splice(3, 1)
        temp.splice(2, 0, element)
      }
      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: {
            pages: temp,
          },
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          paymentStep: "L",
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
    }
    setSectionState(prev => {
      // making section data empty to load new sectionData
      return {
        ...prev,
        sectionId: null,
        sectionData: {},
      }
    })
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        premium:
        (biApiData?.finalKeys.PREMIUM) || 0,
        lastPageCode: props.pageId,
        paymentStep: payNowOrLater === "now" ? "N" : "L",
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        planOption: journeyState.planOption
      },
      // base64Data: pdfData,
    }
    saveApplication(sendPayload).then(res => {
      console.log(res, "application response")
      props.setCurrentSectionIndex(0) // this moves to first section of next page
      props.setCurrentPageIndex(prev => prev + 1)
    }).catch(err => {
      console.log(err, "err in saveApplication benefit-illustration")
    })
  }

  const handleReCalculate = () => {
    if (proceedWithOption === "manually") {
      props.setCurrentPageIndex(0)
      props.setCurrentSectionIndex(0)
      const tempPage = journeyState.journeyData?.find(page => page.pageId === (journeyState.journeyIdFromStrapi === "iSelectJourney" ? "calculatePremiumPage" : "PageISelect360CalculatePremium"))
      console.log(tempPage, "tempPage")

      let sectionsTokeep = tempPage.pageData.filter((section => {
        return !["iSelect360CPOptionalInBuilt", "iSelect360CPSpouseCoverDetails"].includes(section.sectionId)
      }))
      setPageState(prev => {
        return {
          ...prev,
          pageId: tempPage.pageId,
          pageData: sectionsTokeep,
        }
      })
      const tempState = tempPage.pageData.find(section => section.sectionId === "CPPersonalDetailsSection")
      console.log(tempState, "tempState")
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: tempState.sectionId,
          sectionData: tempState.sectionData,
        }
      })
      // setConditionState({})
    }
  }

  return (
    <>
      {/* checkbox css */}
      <style>
        {`/* The container */
      .checkbox-label {
        position: relative;
        padding-left: 35px;
        margin-bottom: 12px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      /* Hide the browser's default checkbox */
      .checkbox-label input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
      }

      /* Create a custom checkbox */
      .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #CCC;
        border-radius:0;
      }

      /* On mouse-over, add a grey background color */
      .checkbox-label:hover input ~ .checkmark {
        background-color: #ccc;
      }

      /* When the checkbox is checked, add a theme background */
      .checkbox-label input:checked ~ .checkmark {
        background-color:  ${journeyState.channel === "A"
            ? "#db0011"
            : journeyState.channel === "B"
              ? "#a20a3a"
              : journeyState.channel === "C"
                ? "#fec32b"
                : "#eb7f25"
          };
        background-color:  var(--lumiq-tertiary);
      };
      }

      /* Create the checkmark/indicator (hidden when not checked) */
      .checkmark:after {
        content: "";
        position: absolute;
        display: none;
      }

      /* Show the checkmark when checked */
      .checkbox-label input:checked ~ .checkmark:after {
        display: block;
      }

      /* Style the checkmark/indicator */
      .checkbox-label .checkmark:after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }`}
      </style>
      <style>
        {`
        .details-card{      
            border-radius:10px;
            overflow:hidden;
            margin-bottom:1rem;
            border:1px solid ${journeyState.channel === "A"
            ? "#000000"
            : journeyState.channel === "B"
              ? "#a20a3a"
              : journeyState.channel === "C"
                ? "#0ab0ef"
                : "#eb7f25"
          };     
            border:1px solid var(--lumiq-secondary);
        }
        
        .details-card::last-child{
            margin-bottom:0;       
        }
        
        .header{
            background: ${journeyState.channel === "A"
            ? "#000000"
            : journeyState.channel === "B"
              ? "#a20a3a"
              : journeyState.channel === "C"
                ? "#0ab0ef"
                : "#eb7f25"
          };
            background: var(--lumiq-secondary);
            color: #fff;
            padding:1rem;
            text-align:center;
        }

        .data{
            display:flex;
            justify-content:space-between;
            padding:1rem;
            color:#797979;

        }
 

        .data:nth-child(odd){
            background:#f3f3f3;
        }

        .data:nth-child(even){}

        .static-content h3{
          font-size:22px
        }

        @media screen and (max-width: 800px){
          .static-content h3{
            font-size: 18px;
          }
            
        }

        .disclosure > *{
            margin-bottom:1rem;

        }      
        .btn-actions{
            display:flex;
            justify-content:center;
            gap:2rem;
            flex-wrap:wrap;
        }

        .btn-actions > * {
          min-width:13rem;
          text-align:center;
        }


        .form-check{
          font-size:1.8rem;
      }

      .form-check-input{
          height:2.5rem;
          width:2.5rem
      }

        @media screen and (max-width:767px){
          .previous-btn{
            padding:0
          }
          
        }

        `}
      </style>
      <style>
        {`
          .input-group.date .input-group-addon{
            background:none;
          }
    
          @media (max-width: 767px){

            .form-group {
              margin-bottom: 34px;
            }
            
          }
          .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
            margin-left:-2px;
          }
          ::-ms-clear {
            display: none;
          }    
          .d-none{
            display: none;
          }   
          .br-0{
            border-radius: 0px !important;
          }
              `}
      </style>

      <div className="landing-page1-design">
        <div className="container">
          {allJourneyData && biApiData && (
            <div className="row">
              <div className="col-md-12 ">
                <div className="iselect-box-design">
                  <div className="heading-design">
                    <div
                      className="iselect-padding left-side-head "
                      style={{ width: "65% !important" }}
                    >
                      <h1 className="iselect-heading">Benefit Illustration</h1>
                      <p style={{ paddingLeft: "1rem", marginTop: "1rem" }}>
                        Canara HSBC Life Insurance Company Limited {lookup['pageTitle'][jounrneyJSON.data.products[0].planId]} | UIN: {lookup['planOptionUIN'][0][journeyState?.planOption]}
                      </p>
                    </div>
                    <div className="app-quatation nri-mt-space hidden-desktop-screen">
                      <div className="application-design-number">
                        Application Number: {journeyState.applicationNo}
                      </div>
                    </div>
                  </div>
                  <div
                    className="iselect-padding"
                    style={{ paddingLeft: "2rem" }}
                  >
                    <h4>
                      Dear{" "}
                      {allJourneyData?.journeyType == "CanaraPos" ?
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.proposerDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.proposerDetails?.title === "MRS" ?  'Mrs. ' : ""
                          : (allJourneyData?.lifeAssuredDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.lifeAssuredDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.lifeAssuredDetails?.title === "MRS" ?  'Mrs. ': ``)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      :
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.gender.toUpperCase() == "M" || allJourneyData?.proposerDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `
                          : (allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "M" || allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      }
                    </h4>
                    <p style={{ color: "#949494" }}>
                      Thank you for showing interest in our {lookup['pageTitle'][jounrneyJSON.data.products[0].planId]}. Based on the details provided by you, the
                      illustration customised to your requirements is appended
                      below.
                    </p>
                  </div>

                  <div className="iselect-padding ">
                    <div className="col-md-6 col-xs-12">
                      <div className="details-card">
                        <div className="header">
                          <span>Life Assured Details</span>
                        </div>
                        <div className="data static-content">
                          <span className="field">Name</span>
                          <span className="value">
                            {wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">Date of Birth</span>
                          <span className="value">
                            {getDateInFormat(
                              allJourneyData.lifeAssuredDetails.dob
                            )}
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">Gender</span>
                          <span className="value">
                            {lineCapital(getValueFromLookup(
                              "gender",
                              allJourneyData.lifeAssuredDetails.gender
                            ) ?? '') || "NA"}
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">Age</span>
                          <span className="value">
                            {JSON.parse(biApiData.BIJson)?.[0]
                              .LI_ATTAINED_AGE ?? "NA"}
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">Category</span>
                          <span className="value">
                            {allJourneyData.lifeAssuredDetails?.personalDetails?.smoking == "Y"
                              ? lineCapital("TOBACCO USER")
                              : lineCapital("NON-TOBACCO USER")}
                          </span>
                        </div>

                        {journeyState.planOption === "IBTML" && (
                          <>
                            <div className="data static-content">
                              <span className="field">
                                Premium Category:</span>
                              <span className="value">
                                {journeyState.planOption === "IBTML"
                                  ? lineCapital("MEDICAL")
                                  : "NA"
                                }
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">
                                Staff/Corporate Customer </span>
                              <span className="value">
                                {allJourneyData.lifeAssuredDetails?.employmentDetails?.staff == "Y" ? "Yes" : "No"
                                }

                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">
                                Existing/Salaried Customer </span>
                              <span className="value">
                                {(allJourneyData.lifeAssuredDetails?.existingPolicyHolder == "Y" || allJourneyData.lifeAssuredDetails?.employmentDetails?.occupation == "1") ? "Yes" : "No"
                                }
                              </span>
                            </div>

                          </>
                        )
                        }

                        <div className="data static-content">
                          <span className="field">Coverage Option</span>
                          <span className="value">
                            {lineCapital(getValueFromLookup(
                              "coverOption",
                              allJourneyData.productDetails.coverOption
                            ) ?? '') || "NA"}
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">Benefit Payout Option</span>
                          <span className="value">
                            {lineCapital(getValueFromLookup(
                              "benefitOption",
                              allJourneyData.productDetails.benefitOption
                            ) ?? '') || "NA"}
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">
                            Benefit Payout (lump sum)* (₹)
                          </span>
                          <span className="value">
                            {
                            // journeyState.planOption === "IATML"
                            //   ? applyComma(JSON.parse(biApiData.BIJson)?.[0]
                            //     .PART_LUMPSUM_AMOUNT ?? '0') || "NA"
                            //   :
                            //   journeyState.planOption === "IBTML"
                            //     ? applyComma(JSON.parse(biApiData.BIJson)?.[0]
                            //       .DB_LUMPSUM_LA ?? '0') || "NA"
                            //     : "NA" 
                            applyComma(biApiData?.finalKeys.BENEFIT_PAYOUT_LUMPSUM ?? '0') || "NA" 
                            }
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">Sum Assured (₹)</span>
                          <span className="value">
                            {applyComma(allJourneyData.productDetails.sumAssured) || "NA"}
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">Plan Option</span>
                          <span className="value">
                            {lineCapital(getValueFromLookup(
                              "planOption",
                              allJourneyData.productDetails.planOption
                            ) ?? '') || "NA"}
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">
                            Life Assured Death Benefit (₹)
                          </span>
                          <span className="value">
                            {applyComma(allJourneyData.productDetails.sumAssured) || "NA"}
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">
                            Benefit Payout (Part lumpsum part monthly income)*
                            Lump sum portion (₹)
                          </span>
                          <span className="value">
                            {applyComma(getValueFromLookup(
                              "lumpsumProportion",
                              allJourneyData.productDetails.proportion
                            ) ?? '') || "NA"}
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">
                            Benefit Payout (Part lumpsum part monthly income)*
                            Monthly income portion (₹)
                          </span>
                          <span className="value">
                            {journeyState.planOption === "IATML"
                              ? applyComma(getValueFromLookup(
                                "benefitPayoutOptionsIndOther",
                                allJourneyData.productDetails
                                  .benefitPayoutOptionsInd
                              ) ?? '') || "NA"
                              
                            : journeyState.planOption === "IBTML"
                                ? applyComma(getValueFromLookup(
                                  "benefitPayoutOptionsIndIselect360",
                                  allJourneyData.productDetails
                                    .benefitPayoutOptionsInd
                                ) ?? '') || "NA"
                                : "NA"
                            }
                          </span>
                        </div>

                        <div className="data static-content">
                          <span className="field">
                            Premium Payment Frequency
                          </span>
                          <span className="value">
                            {lineCapital(getValueFromLookup(
                              "premiumFrequency",
                              allJourneyData.productDetails.modeOfPayment
                            ) ?? '') || "NA"}
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">
                            Premium Paying Term (yrs)
                          </span>
                          <span className="value">
                            {lineCapital(getValueFromLookup(
                              "policyTerm",
                              allJourneyData.productDetails.premiumPaymentTerm
                            ) ?? '') || "NA"}
                          </span>
                        </div>

                        <div className="data static-content">
                          <span className="field">
                            Benefit Payout* Monthly Income (₹):
                          </span>
                          <span className="value">
                            {
                            // journeyState.planOption === "IATML"
                            //   ? applyComma(JSON.parse(biApiData.BIJson)?.[0]
                            //     .part_monthly_amount ?? '0') || "NA"
                            //   :
                            //   journeyState.planOption === "IBTML"
                            //     ? applyComma(JSON.parse(biApiData.BIJson)?.[0]
                            //       .MONTHLY_INCOME_LA ?? '0') || "NA"
                            //     : "NA" 
                            applyComma(biApiData?.finalKeys.BENEFIT_PAYOUT_MONTHLY_INCOME ?? '0') || "NA"
                            }
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">Policy Term (yrs)</span>
                          <span className="value">
                            {lineCapital(getValueFromLookup(
                              "policyTerm",
                              allJourneyData.productDetails.policyTerm
                            ) ?? '') || "NA"}
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">
                            Additional Accidental Death Benefit (₹)
                          </span>
                          <span className="value">
                            {journeyState.planOption === "IATML"
                              ? findRiderSA(
                                "IAADB",
                                allJourneyData.productDetails?.riders?.rider
                              )
                              :
                              journeyState.planOption === "IBTML"
                                ? findRiderSA(
                                  "IBADB",
                                  allJourneyData.productDetails?.riders?.rider
                                )
                                : "NA"
                            }
                          </span>
                        </div>
                        {/* <div className="data static-content">
                        <span className="field">
                          Accidental Total & Permanent Disability Premium
                          Protection Plus (₹)
                        </span>
                        <span className="value">{"NA"}</span>
                      </div> */}
                        {journeyState.planOption === "IATML" && (
                          <div className="data static-content">
                            <span className="field">
                              Child Support Benefit (₹)
                            </span>
                            <span className="value">
                              {findRiderSA(
                                "IACSB",
                                allJourneyData.productDetails?.riders?.rider
                              )

                              }
                            </span>
                          </div>
                        )
                        }
                        {journeyState.planOption === "IBTML" && (
                          <div className="data static-content">
                            <span className="field">
                              Child Care Benefit (₹)
                            </span>
                            <span className="value">
                              {findRiderSA(
                                "IBCSB",
                                allJourneyData.productDetails?.riders?.rider
                              )

                              }
                            </span>
                          </div>
                        )
                        }
                        {journeyState.planOption === "IBTML" && (
                          <>
                            <div className="data static-content">
                              <span className="field">
                                Accidental Total & Permanent Disability (ATPD) - Premium Protection </span>
                              <span className="value">
                                {
                                allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name=== "IBATP1").length==1 ? "Yes" : "NA"
                                }
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">
                                Accidental Total & Permanent Disability (ATPD) - Premium Protection Plus </span>
                              <span className="value">
                                {journeyState.planOption === "IBTML"
                                  ? findRiderSA(
                                    "IBATP2",
                                    allJourneyData.productDetails?.riders?.rider
                                  )
                                  : "NA"
                                }
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">
                                Critical Illness (CI) Benefit - Premium Protection</span>
                              <span className="value">
                                {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name === "IBATC1").length==1 ? "Yes" : "NA"
                                }
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">
                                Critical Illness (CI) Benefit - Premium Protection Plus </span>
                              <span className="value">
                                {journeyState.planOption === "IBTML"
                                  ? findRiderSA(
                                    "IBATC2",
                                    allJourneyData.productDetails?.riders?.rider
                                  )
                                  : "NA"
                                }
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">
                                Terminal Illness (TI) </span>
                              <span className="value">
                                {journeyState.planOption === "IBTML"
                                  ? findRiderSA(
                                    allJourneyData.productDetails.planOption === "IBTML2" ?  "IBTIP2" : "IBTIP", // TI name is IBTIP2 for IBTML2 
                                    allJourneyData.productDetails?.riders?.rider
                                  )
                                  : "NA"
                                }
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">
                                Block Your Premium (BYP) </span>
                              <span className="value">
                              {journeyState.planOption === "IBTML"
                                      ? findRiderSAPercent(
                                        "IBBYP",
                                        allJourneyData.productDetails?.riders?.rider, 'bypSumAssured',"bypSaPercent"
                                      )
                                      : "NA"
                                    }
                                {/* {
                                allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name.includes("IBBYP")).map(data => (
                                  <>
                                    {getValueFromLookup2(
                                      "bypSumAssured",
                                      data.bypSaPercent)}</>
                                ))} */}
                              </span>
                            </div>

                          </>
                        )
                        }
                        {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name === "IBCSB").map(data => (
                          <>
                            <div className="data static-content">
                              <span className="field">
                                Date of Birth of Child </span>
                              <span className="value">
                                {getDateInFormat(
                                  allJourneyData.lifeAssuredDetails?.childDOB
                                )}

                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">
                                Gender of Child </span>
                              <span className="value">
                                {lineCapital(getValueFromLookup(
                                  "gender",
                                  allJourneyData.lifeAssuredDetails?.childGender
                                ) ?? '') || "NA"}
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">
                                CCB Policy Term (Years) </span>
                              <span className="value">
                                {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name==="IBCSB").map(data => (
                                  <div>{data.pt}</div>
                                ))}
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">
                                CCB Premium Payment Term(Years) </span>
                              <span className="value">
                                {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name==="IBCSB").map(data => (
                                  <div>{data.ppt}</div>
                                ))}
                              </span>
                            </div>
                          </>
                        ))}
                        {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name==="IBATC1").map(data => (
                          <div>
                            <div className="data static-content">
                              <span className="field">
                                CI Policy Term (Years) </span>
                              <span className="value">
                                {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name === "IBATC1").map(data => (
                                  <div>{data.pt}</div>
                                ))}
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">
                                CI Premium Payment Term (Years) </span>
                              <span className="value">
                                {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name === "IBATC1").map(data => (
                                  <div>{data.ppt}</div>
                                ))}
                              </span>
                            </div>
                          </div>
                        ))}



                      </div>
                    </div>

                    <div className="col-md-6 col-xs-12">
                      {allJourneyData?.productDetails?.spouseLaDetails
                        ?.wishToSecure === "02" && (
                          <div className="details-card">
                            <div className="header">
                              <span>Spouse Details</span>
                            </div>
                            <div className="data static-content">
                              <span className="field">Name</span>
                              <span className="value">
                                {" "}
                                {allJourneyData?.productDetails?.spouseLaDetails
                                  ?.wishToSecure == "02"
                                  ? wordCapital(allJourneyData?.spouseDetails?.firstName ?? '') +
                                  " " +
                                  wordCapital(allJourneyData?.spouseDetails?.middleName ?? '') +
                                  " " +
                                  wordCapital(allJourneyData?.spouseDetails?.lastName ?? '')
                                  : "NA"}
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">Date of Birth</span>
                              <span className="value">
                                {allJourneyData?.productDetails?.spouseLaDetails
                                  ?.wishToSecure == "02"
                                  ? getDateInFormat(
                                    allJourneyData?.spouseDetails?.dob
                                  )
                                  : "NA"}
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">Gender</span>
                              <span className="value">
                                {allJourneyData?.productDetails?.spouseLaDetails
                                  ?.wishToSecure == "02"
                                  ? lineCapital(getValueFromLookup(
                                    "gender",
                                    allJourneyData?.spouseDetails?.gender
                                  ) ?? '')
                                  : "NA"}
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">Age</span>
                              <span className="value">
                                {allJourneyData?.productDetails?.spouseLaDetails
                                  ?.wishToSecure == "02"
                                  ? JSON.parse(biApiData.BIJson)?.[0]
                                    .SPOUSE_AGE_DISPLAY ?? "NA"
                                  : "NA"}
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">Annual Income</span>
                              <span className="value">
                                {allJourneyData?.productDetails?.spouseLaDetails
                                  ?.wishToSecure == "02"
                                  &&
                                  allJourneyData?.spouseDetails?.employmentDetails?.annualIncome
                                  ? applyComma(allJourneyData?.spouseDetails?.employmentDetails?.annualIncome ?? '')
                                  : "NA"}
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">Sum Assured</span>
                              <span className="value">
                                {allJourneyData?.productDetails?.spouseLaDetails
                                  ?.wishToSecure == "02"
                                  ? applyComma(allJourneyData?.productDetails?.spouseLaDetails
                                    ?.spouseSa ?? '')
                                  : "NA"}
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">Category</span>
                              <span className="value">
                                {allJourneyData?.spouseDetails?.personalDetails?.smoking == "Y"
                                  ? lineCapital("TOBACCO USER")
                                  : lineCapital("NON-TOBACCO USER")}
                              </span>
                            </div>
                            {/* {journeyState.planOption === "IBTML" && (
                              <>
                                <div className="data static-content">
                                  <span className="field">
                                    Staff/Corporate Customer </span>
                                  <span className="value">
                                    No
                                  </span>
                                </div>
                                <div className="data static-content">
                                  <span className="field">
                                    Existing/Salaried Customer </span>
                                  <span className="value">
                                    No
                                  </span>
                                </div>
                              </>
                            )
                            } */}
                            <div className="data static-content">
                              <span className="field">Coverage </span>
                              <span className="value">
                                {getValueFromLookup(
                                  "coverOption",
                                  allJourneyData.productDetails.spouseLaDetails
                                    ?.spouseCoverOption
                                ) || "NA"}
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">Benefit Payout Option</span>
                              <span className="value">
                                {allJourneyData?.productDetails?.spouseLaDetails
                                  ?.wishToSecure == "02"
                                  ? getValueFromLookup(
                                    "benefitOption",
                                    allJourneyData.productDetails
                                      ?.spouseLaDetails?.spousebenAmtRcvInd
                                  )
                                  : "NA"}
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">Plan Option</span>
                              <span className="value">
                                {allJourneyData?.productDetails?.spouseLaDetails
                                  ?.wishToSecure == "02"
                                  ? getValueFromLookup(
                                    "planOption",
                                    allJourneyData.productDetails.planOption
                                  )
                                  : "NA"}
                              </span>
                            </div>
                            {journeyState.planOption === "IBTML" && (
                              <>
                                <div className="data static-content">
                                  <span className="field">
                                    Additional Accidental Death Benefit (₹)
                                  </span>
                                  <span className="value">
                                    {journeyState.planOption === "IBTML"
                                      ? findRiderSA(
                                        "IBADB1",
                                        allJourneyData.productDetails?.riders?.rider
                                      )
                                      : "NA"
                                    }
                                  </span>
                                </div>

                                <div className="data static-content">
                                  <span className="field">
                                    Child Care Benefit (₹)
                                  </span>
                                  <span className="value">
                                    {
                                      journeyState.planOption === "IBTML"
                                        ? findRiderSA(
                                          "IBATC4",
                                          allJourneyData.productDetails?.riders?.rider
                                        )
                                        : "NA"
                                    }
                                  </span>
                                </div>
                                <div className="data static-content">
                                  <span className="field">
                                    Accidental Total & Permanent Disability (ATPD) - Premium Protection </span>
                                  <span className="value">
                                  {
                                    allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name==="IBATP3").length==1 ? "Yes" : "NA"
                                }
                                  </span>
                                </div>
                                <div className="data static-content">
                                  <span className="field">
                                    Accidental Total & Permanent Disability (ATPD) - Premium Protection Plus </span>
                                  <span className="value">
                                    {journeyState.planOption === "IBTML"
                                      ? findRiderSA(
                                        "IBATP4",
                                        allJourneyData.productDetails?.riders?.rider
                                      )
                                      : "NA"
                                    }
                                  </span>
                                </div>
                                <div className="data static-content">
                                  <span className="field">
                                    Critical Illness (CI) Benefit - Premium Protection</span>
                                  <span className="value">
                                  {
                                    allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name === "IBCSB1").length==1 ? "Yes" : "NA"
                                }
                                  </span>
                                </div>
                                <div className="data static-content">
                                  <span className="field">
                                    Critical Illness (CI) Benefit - Premium Protection Plus </span>
                                  <span className="value">
                                    {journeyState.planOption === "IBTML"
                                      ? findRiderSA(
                                        "IBATC3",
                                        allJourneyData.productDetails?.riders?.rider
                                      )
                                      : "NA"
                                    }
                                  </span>
                                </div>
                                <div className="data static-content">
                                  <span className="field">
                                    Terminal Illness (TI) </span>
                                  <span className="value">
                                    {journeyState.planOption === "IBTML"
                                      ? findRiderSA(
                                        "IBTIP1",
                                        allJourneyData.productDetails?.riders?.rider
                                      )
                                      : "NA"
                                    }
                                  </span>
                                </div>
                                <div className="data static-content">
                                  <span className="field">
                                    Block Your Premium (BYP) </span>
                                  <span className="value">
                                  {journeyState.planOption === "IBTML"
                                      ? findRiderSAPercent(
                                        "IBBYP1",
                                        allJourneyData.productDetails?.riders?.rider, "bypSumAssured","bypSpouseSaPercent"
                                      )
                                      : "NA"
                                    }
                                    {/* {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name.includes("IBBYP1")).map(data => (
                                      <>
                                        {getValueFromLookup2(
                                          "bypSumAssured",
                                          data.bypSpouseSaPercent) || "NA"}</>
                                    ))} */}
                                  </span>
                                </div>
                                {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name === "IBATC4").map(data => (
                                  <>
                                    <div className="data static-content">
                                      <span className="field">
                                        Date of Birth of Child </span>
                                      <span className="value">
                                        {getDateInFormat(
                                          allJourneyData.spouseDetails?.childDOB
                                        )}
                                      </span>
                                    </div>
                                    <div className="data static-content">
                                      <span className="field">
                                        Gender of Child </span>
                                      <span className="value">
                                        {lineCapital(getValueFromLookup(
                                          "gender",
                                          allJourneyData.spouseDetails?.childGender
                                        ) ?? '') || "NA"}
                                      </span>
                                    </div>
                                    <div className="data static-content">
                                      <span className="field">
                                        CCB Policy Term (Years) </span>
                                      <span className="value">
                                        {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name==="IBATC4").map(data => (
                                          <div>{data.pt}</div>
                                        ))}
                                      </span>
                                    </div>
                                    <div className="data static-content">
                                      <span className="field">
                                        CCB Premium Payment Term(Years) </span>
                                      <span className="value">
                                        {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name === "IBATC4").map(data => (
                                          <div>{data.ppt}</div>
                                        ))}
                                      </span>
                                    </div>
                                  </>
                                ))}
                                {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name ==="IBATC1").map(data => (
                                  <div>
                                    <div className="data static-content">
                                      <span className="field">
                                        CI Policy Term (Years) </span>
                                      <span className="value">
                                        {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name === "IBATC1").map(data => (
                                          <div>{data.pt}</div>
                                        ))}
                                      </span>
                                    </div>
                                    <div className="data static-content">
                                      <span className="field">
                                        CI Premium Payment Term (Years) </span>
                                      <span className="value">
                                        {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name === "IBATC1").map(data => (
                                          <div>{data.ppt}</div>
                                        ))}
                                      </span>
                                    </div>
                                  </div>
                                ))}

                              </>
                            )
                            }


                          </div>
                        )}
                      <div className="details-card">
                        <div className="header">
                          <span>Total Premium Payable (₹)</span>
                        </div>
                        <div className="data static-content">
                          <span className="field">
                            Installment Premium (Life Assured + Rider Premium
                            (If applicable))
                          </span>
                          <span className="value">
                            {
                            // journeyState.planOption === "IATML"
                            //   ? applyComma(`${JSON.parse(biApiData?.BIJson)[0].TOTAL_1}` ?? '')
                            //   : journeyState.planOption === "IBTML"
                            //     ? applyComma(`${JSON.parse(biApiData?.BIJson)[0].TOTAL_PREM_LA}` ?? '')
                            //     : "NA"
                            applyComma(biApiData?.finalKeys.INSTALLMENT_PREM_LA_RIDER ?? '')
                                }
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">
                            Installment Premium (Spouse Cover)
                          </span>
                          <span className="value">
                            {
                            // journeyState.planOption === "IATML"
                            //   ? applyComma(`${JSON.parse(biApiData.BIJson)[0].TOTAL_2}` ?? '')
                            //   : journeyState.planOption === "IBTML"
                            //     ? applyComma(`${JSON.parse(biApiData.BIJson)[0]
                            //       .TOTAL_SPOUSE_PREM}` ?? '') || 0
                            //     : "NA"
                            applyComma(biApiData?.finalKeys.INSTALLMENT_PREM_SPOUSE ?? '') || 0
                                }
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">Total Installment</span>
                          <span className="value">
                            {
                            // journeyState.planOption === "IATML"
                            //   ? applyComma(`${JSON.parse(biApiData.BIJson)[0].MODAL_PREM}` ?? '')
                            //   : journeyState.planOption === "IBTML"
                            //     ? applyComma(`${(
                            //       JSON.parse(biApiData.BIJson)[0]
                            //         .TOTAL_PREM_LA +
                            //       JSON.parse(biApiData.BIJson)[0]
                            //         .TOTAL_SPOUSE_PREM || 0
                            //     )?.toFixed(2)}` ?? '')
                            //     : "NA"
                            applyComma(biApiData?.finalKeys?.TOTAL_INSTALLMENT ?? '') || 0
                                }
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">
                            Goods and Services Tax & Applicable Cess (es)/Levy,
                            if any
                          </span>
                          <span className="value">
                            { 
                            //  journeyState.planOption === "IATML"
                            //   ? JSON.parse(biApiData.BIJson)[0].TAX_MP
                            //   : journeyState.planOption === "IBTML"
                            //     ? journeyState.gstWaiverInd === "N" ?
                            //       applyComma(`${(
                            //       (JSON.parse(biApiData.BIJson)[0]
                            //         .TOTAL_BASE_PREM_TAX +
                            //         JSON.parse(biApiData.BIJson)[0]
                            //           .TOTAL_PREM_TAX_SPOUSE || 0) -
                            //       (JSON.parse(biApiData.BIJson)[0]
                            //         .TOTAL_PREM_LA +
                            //         JSON.parse(biApiData.BIJson)[0]
                            //           .TOTAL_SPOUSE_PREM || 0)
                            //     )?.toFixed(2)}` ?? '')
                            //     : 0 :"NA" 
                            applyComma(biApiData?.finalKeys?.SERVICE_TAX ?? '') || 0
                                
                              }
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">Amount Payable</span>
                          <span className="value">
                            {
                            // journeyState.planOption === "IATML"
                            //   ? applyComma(`${JSON.parse(biApiData.BIJson)[0].TOTAL_5}` ?? '')
                            //   : journeyState.planOption === "IBTML"
                            //     ? ((
                            //       JSON.parse(biApiData.BIJson)[0]
                            //         .TOTAL_BASE_PREM_TAX +
                            //       JSON.parse(biApiData.BIJson)[0]
                            //         .TOTAL_PREM_TAX_SPOUSE || 0
                            //     )?.toFixed(2) ?? '')
                            //     : "NA"
                            applyComma(biApiData?.finalKeys?.PREMIUM ?? '') || 0
                                }
                          </span>
                        </div>
                        <div className="data static-content">
                          <span className="field">
                            Total Amount Payable for the Year
                          </span>
                          <span className="value">
                            {
                            // journeyState.planOption === "IATML"
                            //   ? applyComma(`${JSON.parse(biApiData.BIJson)[0].ANN_TOTAL_5}` ?? '')
                            //   : journeyState.planOption === "IBTML"
                            //     ? applyComma(`${JSON.parse(biApiData.BIJson)[0].TOTAL}` ?? '')
                            //     : "NA"
                            applyComma(biApiData?.finalKeys?.TOTAL_AMOUNT_PER_YEAR ?? '') || 0
                                }
                          </span>
                        </div>
                      </div>
                    </div>

                    <p
                      className="text-center col-md-12 col-xs-12"
                      style={{
                        padding: "2rem 4rem",
                      }}
                    >
                      This is applicable only for Level Cover Option. For
                      Increasing Cover Option the amount will increase as per
                      terms and conditions of the policy.
                    </p>

                    <div className="btn-actions col-md-12 col-xs-12">
                      <div
                        style={{ cursor: "pointer" }}
                        className="provider submit-btn"
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterDownload(e)}
                        onClick={downloadPdf}
                      >
                        <a>Download</a>
                      </div>
                      <div
                        style={{ cursor: "pointer" }}
                        className="provider submit-btn"
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterPrint(e)}
                        onClick={printPdf}
                      >
                        <a>Print</a>
                      </div>
                      <div
                        style={{ cursor: "pointer" }}
                        className="provider submit-btn"
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterEmail(e)}
                        onClick={() => {sendEmail(false)}}
                      >
                        <a>Email</a>
                      </div>
                      <div
                        style={{
                          cursor:
                            proceedWithOption === "manually"
                              ? "pointer"
                              : "default",
                        }}
                        className={
                          proceedWithOption === "manually"
                            ? "provider submit-btn"
                            : "provider manually-submit-btn"
                        }
                        tabIndex="0"
                        disabled={
                          proceedWithOption === "manually" ? false : true
                        }
                        onKeyPress={(e) => handleEnterRecalculate(e)}
                        onClick={handleReCalculate}
                      >
                        <a>Re-Calculate</a>
                      </div>
                    </div>
                  </div>

                  <div className="iselect-padding">
                    <div className="col-md-6 col-xs-12 ">
                      <RadioContainer channel={journeyState.channel}>
                        <div style={{ borderRadius: '15px' }} className="provider" tabIndex="0" onKeyPress={(event) => handleEnterPayoutOption(event, "now")}>
                          <label className="width">
                            <input
                              type="radio"
                              name="pay"
                              value="now"
                              hidden
                              onChange={handlePayOption}
                              checked={payNowOrLater == 'now' ? true : false}
                            />
                            <div className="card">
                              <div className="checked">
                                <FaCheck />
                              </div>
                              <div className="amount">
                                <span>
                                  Pay{" "}
                                  {`₹${
                                    // journeyState.planOption === "IATML"
                                    // ? JSON.parse(biApiData.BIJson)[0].TOTAL_5
                                    // : journeyState.planOption === "IBTML"
                                    //   ? (
                                    //     JSON.parse(biApiData.BIJson)[0]
                                    //       .TOTAL_BASE_PREM_TAX +
                                    //     JSON.parse(biApiData.BIJson)[0]
                                    //       .TOTAL_PREM_TAX_SPOUSE || 0
                                    //   )?.toFixed(2)
                                    //   : "NA"
                                    (biApiData?.finalKeys.PREMIUM) || 0
                                    
                                    }`}{" "}
                                  Now!
                                </span>
                              </div>

                              <div className="desc">
                                <span>
                                  Pay your {getValueFromLookup("premiumFrequencyToShowInBI", allJourneyData.productDetails?.modeOfPayment)} Premium
                                  <b>
                                    {" "}
                                    {`₹${
                                      // journeyState.planOption === "IATML"
                                      // ? JSON.parse(biApiData.BIJson)[0]
                                      //   .TOTAL_5
                                      // : journeyState.planOption === "IBTML"
                                      //   ? (
                                      //     JSON.parse(biApiData.BIJson)[0]
                                      //       .TOTAL_BASE_PREM_TAX +
                                      //     JSON.parse(biApiData.BIJson)[0]
                                      //       .TOTAL_PREM_TAX_SPOUSE || 0
                                      //   )?.toFixed(2)
                                      //   : "NA"
                                      (biApiData?.finalKeys.PREMIUM) || 0
                                      
                                      }`}{" "}
                                  </b>{" "}
                                  now and proceed.
                                </span>
                              </div>
                            </div>
                          </label>
                        </div>
                      </RadioContainer>
                    </div>

                    <div className="col-md-6 col-xs-12 ">
                      <RadioContainer>
                        <div style={{ borderRadius: '15px' }} className="provider" tabIndex="0" onKeyPress={(event) => handleEnterPayoutOption(event, "later")}>
                          <label className="width">
                            <input
                              type="radio"
                              name="pay"
                              value="later"
                              hidden
                              checked={payNowOrLater == 'later' ? true : false}
                              onChange={handlePayOption}
                            />
                            <div className="card">
                              <div className="checked">
                                <FaCheck />
                              </div>
                              <div className="amount">
                                <span>
                                  Pay{" "}
                                  {`₹${
                                    // journeyState.planOption === "IATML"
                                    // ? JSON.parse(biApiData.BIJson)[0].TOTAL_5
                                    // : journeyState.planOption === "IBTML"
                                    //   ? (
                                    //     JSON.parse(biApiData.BIJson)[0]
                                    //       .TOTAL_BASE_PREM_TAX +
                                    //     JSON.parse(biApiData.BIJson)[0]
                                    //       .TOTAL_PREM_TAX_SPOUSE || 0
                                    //   )?.toFixed(2)
                                    //   : "NA"
                                    (biApiData?.finalKeys.PREMIUM) || 0
                                    
                                    }`}{" "}
                                  Later!
                                </span>
                              </div>

                              <div className="desc">
                                <span>
                                  Continue with your application and pay
                                  <b>
                                    {" "}
                                    {`₹${
                                      // journeyState.planOption === "IATML"
                                      // ? JSON.parse(biApiData.BIJson)[0]
                                      //   .TOTAL_5
                                      // : journeyState.planOption === "IBTML"
                                      //   ? (
                                      //     JSON.parse(biApiData.BIJson)[0]
                                      //       .TOTAL_BASE_PREM_TAX +
                                      //     JSON.parse(biApiData.BIJson)[0]
                                      //       .TOTAL_PREM_TAX_SPOUSE || 0
                                      //   )?.toFixed(2)
                                      //   : "NA"
                                      (biApiData?.finalKeys.PREMIUM) || 0
                                      
                                      }`}{" "}
                                  </b>{" "}
                                  later.
                                </span>
                              </div>
                            </div>
                          </label>
                        </div>
                      </RadioContainer>
                    </div>
                  </div>

                  <div className="iselect-mg-bottom check-design">
                    <div className="col-md-12 col-xs-12">
                      <div className="transactionDetailsWrap del-agree">
                        <div className="detailContentWrap">
                          <div
                            className="row iAgree"
                            style={{ textAlign: "center" }}
                          >
                            <div className="form-group">
                              <div className="inner-addon left-addon align-error payment-align-error" >
                                <div className="checkbox1">
                                  <input
                                    id="checkboxG6"
                                    className={`css-checkbox form-control`}
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={handleOnChange}
                                  />

                                  <label
                                    htmlFor="checkboxG6"
                                    className="css-label"
                                  >
                                    I agree to the Disclosures and Disclaimers
                                    as mentioned below.
                                  </label>
                                </div>
                                {!isChecked && (<span className="input-error " style={{ fontSize: '13px', marginLeft: "5.2rem" }}>
                                  Please accept Terms & Conditions
                                </span>)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* 
                  <div
                    style={{
                      textAlign: "center",
                      marginBottom: "4rem",
                    }}
                  >
                    <label className="checkbox-label static-content">
                      I agree to the Disclosures and Disclaimers as mentioned
                      below.
                      <input type="checkbox" onClick={handleAgreeChange} />
                      <span className="checkmark"></span>
                    </label>
                  </div> */}

                  <div className="iselect-mg-bottom hidden-desktop-screen">
                    <div className="col-md-12">
                      <div className="but-center text-center">
                        <div
                          className={
                            proceedWithOption === "manually"
                              ? "provider submit-btn cen"
                              : "provider manually-submit-btn cen"
                          } tabIndex="0" onKeyPress={(e) => handleEnterPrevious(e)}
                        >
                          <a
                            style={{
                              cursor:
                                proceedWithOption === "manually"
                                  ? "pointer"
                                  : "default",
                            }}
                            aria-hidden="true"
                            onClick={handlePrevious}
                          >
                            Previous
                          </a>
                        </div>
                        <input
                          type="submit"
                          className="provider previous-btn cen"
                          tabIndex="0"
                          style={{
                            color: "white",
                            padding: "14px 40px",
                            border: "none",
                            marginLeft: "8px",
                          }}
                          value="Proceed"
                          onClick={handleProceed}
                          disabled={!agreeToDeclaration}
                        />
                      </div>
                    </div>
                  </div>
                  {journeyState.channel === "A" ? (
                    <div className="static-content">
                      <h3
                        style={{
                          marginLeft: "2rem",
                          marginTop: "19rem",
                        }}
                      >
                        Disclosures:{" "}
                      </h3>
                      <ol className="disclosure">
                        <li>
                          Canara HSBC Life Insurance Company Limited {lookup['pageTitle'][jounrneyJSON.data.products[0].planId]} is an Individual Non-Linked
                          Non-Par Pure Risk Premium Life Insurance Term Plan.
                        </li>
                        <li>
                          Tax benefits under the plan will be as per the
                          prevailing Income Tax laws and are subject to
                          amendments from time to time. For tax related queries,
                          contact your independent tax advisor.
                        </li>
                        <li>
                          The above illustration takes into account currently
                          applicable Goods and Services Tax including applicable
                          cess(es)/other levy, if any. However, the applicable
                          taxes may change from time to time and premium payable
                          will change accordingly.
                        </li>
                        <li>
                          In case of Regular/ Limited Pay policies, if due
                          premium is not paid within the Grace Period, then
                          policy will lapse at the expiry of the Grace Period.
                          For Regular Pay policies, insurance cover will cease
                          immediately. However, for Limited Pay policies,
                          provided all the premiums due for the first 2
                          consecutive policy years have been paid, an Early Exit
                          Value shall be payable on the earliest of the
                          following terminations: a) death of the life assured/
                          spouse when policy has lapsed b) request for
                          termination of the policy by the policyholder c)
                          expiry of revival period.
                        </li>
                        <li>
                          If Monthly Income Benefit Payout Period is chosen as
                          "Till end of Policy Term", the same is subject to
                          maximum of 40 years
                        </li>
                      </ol>
                      <h3
                        style={{
                          marginLeft: "2rem",
                        }}
                      >
                        Disclaimers:
                      </h3>
                      <ol className="disclosure">
                        <li>
                          Issuance of the policy and acceptance of the risk is
                          completely at the discretion of the Canara HSBC
                           Life Insurance Company
                          Limited ("Company") and this premium quotation would
                          in no way be tantamount to acceptance of risk by the
                          Company.
                        </li>
                        <li>
                          The above premium is for a healthy individual. Your
                          application will be assessed as per Board Approved
                          Underwriting Policy of the Company. Basis
                          underwriting, it may result in an extra premium to be
                          paid, which shall be borne by you.
                        </li>
                        <li>
                          These figures are assuming happening of event at
                          policy inception.
                        </li>
                        <li>
                          For more details on risk factors, terms and
                          conditions, please read sales brochure carefully
                          before concluding a sale.
                        </li>
                        <li>
                          The mentioned quote is valid till next birthday or 30
                          days from the quote generation date whichever is
                          earlier.
                        </li>
                        <li>
                          For any further clarifications, please feel free to
                          contact us at {getSourceFromChannel(journeyState.channel) === "U" ?  "1800-258-5899" : "1800-891-0003"} or email us
                          at {getSourceFromChannel(journeyState.channel) === "U" ? "onlineterm@canarahsbclife.in" : "customerservice@canarahsbclife.in"} or visit our
                          website{" "}
                          <a
                            href="https://www.canarahsbclife.com"
                            target="_blank"
                          >
                            www.canarahsbclife.com.
                          </a>
                        </li>
                      </ol>
                    </div>
                  ) : (
                    <div className="static-content">
                      <h3
                        style={{
                          marginLeft: "2rem",
                          marginTop: "19rem",
                        }}
                      >
                        Disclosures:{" "}
                      </h3>
                      <ol className="disclosure">
                        <li>
                          Canara HSBC Life Insurance Company Limited {lookup['pageTitle'][jounrneyJSON.data.products[0].planId]} is an Individual Non-Linked
                          Non-Par Pure Risk Premium Life Insurance Term Plan.
                        </li>
                        <li>
                          Tax benefits under the plan will be as per the
                          prevailing Income Tax laws and are subject to
                          amendments from time to time. For tax related queries,
                          contact your independent tax advisor.
                        </li>
                        <li>
                          The above illustration takes into account currently
                          applicable Goods and Services Tax including applicable
                          cess(es)/other levy, if any. However, the applicable
                          taxes may change from time to time and premium payable
                          will change accordingly.
                        </li>
                        <li>
                          In case of Regular/ Limited Pay policies under plan
                          option Life, if due premium is not paid within the
                          Grace Period, then policy will lapse at the expiry of
                          the Grace Period. For Regular Pay policies, insurance
                          cover will cease immediately. However, for Limited Pay
                          policies, provided all the premiums due for the first
                          2 consecutive policy years have been paid, an Early
                          Exit Value shall be payable on the earliest of the
                          following terminations: a) death of the life assured/
                          spouse when policy has lapsed b) request for
                          termination of the policy by the policyholder c)
                          expiry of revival period.
                        </li>
                        <li>
                          In case of Regular/ Limited Pay policies under plan
                          option Life with ROP and Life Plus, if due premium is
                          not paid within the Grace Period, then the policy will
                          lapse at the expiry of the Grace Period. Once the
                          policy is in lapse status, no benefit shall be paid on
                          death or upon request for termination of the policy or
                          on the expiry of the revival period. If a policy in
                          lapse status is not revived within the revival period,
                          it shall terminate upon expiry of the revival period.
                        </li>
                        <li>
                          Under plan option Life with ROP and Life Plus, the
                          policy will acquire a paid-up status at the expiry of
                          the Grace Period from the due date of the first unpaid
                          premium, provided first 2 consecutive policy years’
                          premiums have been paid. Once the policy is in paid-up
                          status and provided the policy is not surrendered or
                          revived, the paid-up benefits will be available during
                          the Policy Term.
                        </li>
                        <li>
                          In Single Premium policies under plan option Life, the
                          surrender benefit will be available from the first
                          policy year and in case of Limited Premium policies
                          under plan option Life, the surrender benefit will be
                          available after payment of all premiums due under the
                          Policy as per the chosen Premium Payment Term. In
                          Regular Premium policies under plan option Life, Early
                          Exit Values/ Surrender Benefit is not applicable.
                        </li>
                        <li>
                          Under plan option Life with ROP and Life Plus, the
                          policy acquires a Guaranteed Surrender Value (GSV) and
                          Special Surrender Value (SSV) only after payment of at
                          least 2 consecutive policy years’ premiums. The
                          Surrender Value payable will be higher of GSV or SSV.
                          Under plan option Life Plus, GSV will only be
                          available during the Policy Term.
                        </li>
                        <li>
                          Annualized Premium is the premium payable in a year
                          for the Base Death / Terminal Illness benefit,
                          excluding taxes, rider premiums and underwriting extra
                          premiums, if any, but including the loadings for modal
                          premiums, if any.
                        </li>
                        <li>
                          Total Premiums Paid means total of all the premiums
                          received for Life Assured / Spouse, excluding the
                          underwriting extra premiums, if any, rider premiums
                          and taxes.
                        </li>
                        <li>
                          If Monthly Income Benefit Payout Period is chosen as
                          "Till end of Policy Term", the same is subject to
                          maximum of 40 years.
                        </li>
                      </ol>
                      <h3
                        style={{
                          marginLeft: "2rem",
                        }}
                      >
                        Disclaimers:
                      </h3>
                      <ol className="disclosure">
                        <li>
                          Issuance of the policy and acceptance of the risk is
                          completely at the discretion of Canara HSBC
                          Bank of Commerce Life Insurance Company Limited
                          ("Company") and this premium quotation would in no way
                          be tantamount to acceptance of risk by the Company.
                        </li>
                        <li>
                          The above premium is for a healthy individual. Your
                          application will be assessed as per Board Approved
                          Underwriting Policy of the Company. Basis
                          underwriting, it may result in an extra premium to be
                          paid, which shall be borne by you.
                        </li>
                        <li>
                          These figures are assuming happening of event at
                          policy inception.
                        </li>
                        <li>
                          For more details on risk factors, terms and
                          conditions, please read sales brochure carefully
                          before concluding a sale.
                        </li>
                        <li>
                          The mentioned quote is valid till next birthday or 30
                          days from the quote generation date whichever is
                          earlier.
                        </li>
                        <li>
                          For any further clarifications, please feel free to
                          contact us at {getSourceFromChannel(journeyState.channel) === "U" ?  "1800-258-5899" : "1800-891-0003"} or email us
                          at {getSourceFromChannel(journeyState.channel) === "U" ? "onlineterm@canarahsbclife.in" : "customerservice@canarahsbclife.in"} or visit our
                          website{" "}
                          <a
                            href="https://www.canarahsbclife.com"
                            target="_blank"
                          >
                            www.canarahsbclife.com.
                          </a>
                        </li>
                      </ol>
                    </div>
                  )}

                  {/* <!--mobile view button--> */}
                  <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1">
                    <div className="iselect-mg-bottom">
                      <div className="col-md-12">
                        <div className="but-center text-center">
                          <div
                            className="submit-btn cen"
                            style={{ marginRight: "5px" }}
                          >
                            {" "}
                            <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                          </div>
                          <div className="previous-btn cen">
                            <a>
                              {" "}
                              <button
                                type="submit"
                                value="button1"
                                style={{
                                  backgroundColor: "transparent",
                                  padding: "14px 10px",
                                  border: "none",
                                  color: "#fff",
                                }}
                                onClick={handleProceed}
                                disabled={!agreeToDeclaration}
                              >
                                Proceed
                              </button>{" "}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!--mobile view button-->  */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
